import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/Core/services/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.css'],
})
export class ToolbarComponent implements OnInit {
  userName: string | undefined;
  isAdvertisementActive = false;
  isOtaActive = false;

  constructor(private auth: AuthService, private dialog: MatDialog, private router: Router, private route: ActivatedRoute) {
    this.router.events.subscribe(() => this.checkActiveRoute());
  }

  checkActiveRoute() {
    const currentUrl = this.router.url;
    this.isAdvertisementActive = currentUrl.startsWith('/upload') || currentUrl.startsWith('/notification');
    this.isOtaActive = currentUrl.startsWith('/ota-dashboard') || currentUrl.startsWith('/ota-device-key');
  }

  navigate(route: string) {
    this.router.navigate([route]);
    this.isAdvertisementActive = true; 
  }

  ngOnInit() {
    this.auth.getUserInfo().subscribe((res) => {
      if (res != null) {
        this.userName = res.name;
      }
    });
  }

  logout() {
    this.auth.doLogout();
  }
}
